import { createAsyncThunk, createSlice, UnknownAction } from '@reduxjs/toolkit';
import {
  GetQuestionsResponse,
  JoinQuestionnaireResponse,
} from '../../get-care/Components/select-visit-reason/types';
import QuestionnaireService from '../../../api/services/QuestionnaireService';
import { RootState } from '../../../store';

type QuestionnaireState = {
  questionnaires: JoinQuestionnaireResponse | null;
  questions: GetQuestionsResponse | null;
  status: 'pending';
  isLoading: false;
};

const initialState: QuestionnaireState = {
  questionnaires: null,
  questions: null,
  status: 'pending',
  isLoading: false,
};

const ACTIONS_PREFIX = 'questionnaires';

export const joinQuestionnaireThunk = createAsyncThunk(
  `${ACTIONS_PREFIX}/joinQuestionnaireThunk`,
  QuestionnaireService.joinQuestionnaire,
);
export const getQuestionsThunk = createAsyncThunk(
  `${ACTIONS_PREFIX}/getQuestionsThunk`,
  QuestionnaireService.getQuestions,
);
export const submitQuestionsThunk = createAsyncThunk(
  `${ACTIONS_PREFIX}/submitQuestionsThunk`,
  QuestionnaireService.submitQuestion,
);
export const submitQuestionnaireThunk = createAsyncThunk(
  `${ACTIONS_PREFIX}/submitQuestionnaireThunk`,
  QuestionnaireService.submitQuestionnaire,
);

const questionnaireSlice = createSlice({
  name: 'getCare',
  initialState,
  reducers: {
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    clearQuestionnaireState: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    // builder.addCase(joinQuestionnaireThunk.fulfilled, (state, action) => {
    //   const questioners = action.payload.resource as JoinQuestionnaireResponse;
    //   state.questioners = questioners;
    // });
    builder.addCase(getQuestionsThunk.fulfilled, (state, action) => {
      const questions = action.payload.resource as GetQuestionsResponse;
      state.questions = questions;
    });
    builder.addMatcher(
      (action: UnknownAction) =>
        (action.type as string).startsWith(ACTIONS_PREFIX) &&
        (action.type as string).endsWith('/fulfilled'),
      (state) => {
        Object.assign(state, {
          isLoading: false,
          status: 'success',
        });
      },
    );
    builder.addMatcher(
      (action: UnknownAction) =>
        (action.type as string).startsWith(ACTIONS_PREFIX) &&
        (action.type as string).endsWith('/pending'),
      (state) => {
        Object.assign(state, {
          isLoading: true,
          status: 'loading',
          error: '',
        });
      },
    );
    builder.addMatcher(
      (action: UnknownAction) =>
        (action.type as string).startsWith(ACTIONS_PREFIX) &&
        (action.type as string).endsWith('/rejected'),
      (state, action) => {
        Object.assign(state, {
          isLoading: false,
          status: 'failure',
          error: action || '',
        });
      },
    );
  },
});

// ACTIONS
export const { setIsLoading, clearQuestionnaireState } = questionnaireSlice.actions;

// selectors
export const questionnaireState = (state: RootState) => state.questionnaires;

export default questionnaireSlice.reducer;
